// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.display-type--container[data-v-736d736e] {\n  width: 240px;\n}\n.example-formula--wrapper[data-v-736d736e] {\n  background-color: #ffffff;\n  width: 300px;\n  border:1px solid #ddd;\n  padding: 16px;\n}\n.example-formula--text[data-v-736d736e] {\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
